<form #form="ngForm" autocomplete="off">
    <div class="app-grid">
        <p
            class="columns-12 margin-bottom-0 approval-flow-label"
            [innerHTML]="'time-off-v3.selectTheTimeOffPolicies' | translate: { name: approvalFlow.name } | sanitizeHtml"
        ></p>
        <mat-form-field class="columns-12">
            <mat-select
                name="years"
                [(ngModel)]="selectedPoliciesIds"
                placeholder="{{ 'time-off-v3.selectPolicies' | translate }}"
                multiple
            >
                <mat-option *ngFor="let policy of policies" [value]="policy.id" [disabled]="isAlreadyAssigned(policy)">
                    <span>{{ policy.name }} - {{ policy.timeOffType.name }}</span>
                    <span *ngIf="isAlreadyAssigned(policy)">{{ 'time-off-v3.alreadyAssigned' | translate }}</span>
                </mat-option>
            </mat-select>
        </mat-form-field>
    </div>
</form>
